// This is a temporary service used to change location from the Angular app

angular.
module("dx.webapp.angular").
factory("dxLocationHelper", function locationHelperService(
	$location,

	DX_URLS
) {
	"use strict";

	function path(p) {
		$location.path(p);
	}

	function navigateTo(route) {
		$location.path(DX_URLS.get(route));
	}

	return {
		path: path,
		navigateTo: navigateTo,
	};
});
